import React from 'react';
import { Warnung } from '../types';
import './WarnungenPanel.css';

interface WarnungenPanelProps {
  warnungen: Warnung[];
  onClose: () => void;
  onMarkRead: (id: number) => void;
  onMarkAllRead: () => void;
}

const TYP_ICON: Record<string, string> = {
  MINDESTBESTAND: 'LAG',
  ZERTIFIKAT_ABLAUF: 'ZRT',
  AUFTRAG_UEBERFAELLIG: '⏰',
  REKLAMATION_OFFEN: 'REK',
  FEUCHTIGKEITSGEHALT: 'FGT',
  RECHNUNG_UEBERFAELLIG: 'OPO',
  EINGANGSRECHNUNG_UNBEARBEITET: 'ER',
};

const PRIORITAET_LABEL: Record<string, string> = {
  HOCH: 'Hoch',
  MITTEL: 'Mittel',
  INFO: 'Info',
};

const WarnungenPanel: React.FC<WarnungenPanelProps> = ({
  warnungen,
  onClose,
  onMarkRead,
  onMarkAllRead,
}) => {
  const sortiert = [...warnungen].sort((a, b) => {
    const order = { HOCH: 0, MITTEL: 1, INFO: 2 };
    return order[a.prioritaet] - order[b.prioritaet];
  });

  const formatDatum = (dateStr: string) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="warnungen-overlay" onClick={onClose}>
      <div className="warnungen-panel" onClick={e => e.stopPropagation()}>
        <div className="warnungen-header">
          <h3>Warnungen</h3>
          <div className="warnungen-header-actions">
            {warnungen.length > 0 && (
              <button className="alle-lesen-btn" onClick={onMarkAllRead}>
                Alle als gelesen
              </button>
            )}
            <button className="warnungen-close" onClick={onClose}>✕</button>
          </div>
        </div>

        <div className="warnungen-liste">
          {sortiert.length === 0 ? (
            <div className="warnungen-leer">
              <span className="warnungen-leer-icon">✓</span>
              <p>Keine ungelesenen Warnungen</p>
            </div>
          ) : (
            sortiert.map(w => (
              <div
                key={w.warnung_id}
                className={`warnung-item prioritaet-${w.prioritaet.toLowerCase()}`}
              >
                <div className="warnung-icon">{TYP_ICON[w.typ] || '—'}</div>
                <div className="warnung-content">
                  <div className="warnung-titel">{w.titel}</div>
                  <div className="warnung-nachricht">{w.nachricht}</div>
                  <div className="warnung-meta">
                    <span className={`warnung-prio prio-${w.prioritaet.toLowerCase()}`}>
                      {PRIORITAET_LABEL[w.prioritaet]}
                    </span>
                    <span className="warnung-datum">{formatDatum(w.erstellt_am)}</span>
                  </div>
                </div>
                <button
                  className="warnung-lesen-btn"
                  onClick={() => onMarkRead(w.warnung_id)}
                  title="Als gelesen markieren"
                >
                  ✓
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default WarnungenPanel;
